export const MY_SENSEFLY: string = 'my-sensefly';
export const HAS_REGISTERED_PRODUCT: string = 'has_registered_product';



// WEBPACK FOOTER //
// ./src/static/variables.ts